import { configureStore, combineReducers } from "@reduxjs/toolkit";
import webReportV1Reducer from "../../app/containers/WebReportV1/slice";
import loginReducer from "../../app/containers/Login/slice";
import createAccountReducer from "../../app/containers/CreateAccount/slice";
import verifyEmailReducer from "../../app/containers/VerifyEmail/slice";
import dashboardReducer from "../../app/containers/Dashboard/slice";
import userProfileReducer from "../../app/containers/UserInfo/slice";
import templatesReducer from "../../app/containers/Templates/slice";
import calendarReducer from "../../app/containers/JobCalendar/slice";
import agentsReducer from "../../app/containers/AgentManagement/slice";

const rootReducer = combineReducers({
  webReportV1: webReportV1Reducer,
  login: loginReducer,
  createAccount: createAccountReducer,
  verifyEmail: verifyEmailReducer,
  dashboard: dashboardReducer,
  userProfile: userProfileReducer,
  templates: templatesReducer,
  calendar: calendarReducer,
  agents: agentsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export function setupStore(preloadedState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
}
